import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import { CheckCircleFill, Transparency } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { DisbursementCard } from '../components/DisbursementCard';

export const CreateDisbursementSuccessPage = () => {
  // se recupera el identificador del pago
  const { id } = useParams();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const onCancel = () => {
    const url = '/';
    navigate(url);
  };

  return (
    <>
      <PageTitle title="Disbursement" subtitle="Between jurisdictions" icon={Transparency} />

      <div className={`alert alert-success fw-bold`}>
        <div className="d-flex justify-content-start gap-4 mt-0">
          <div className="me-4">
            <CheckCircleFill size={45} />
          </div>
          <div>
            <div>
              <h3> {t(`disbursement.recordSuccess`)}</h3>
            </div>
            <div className="text-muted">{t(`disbursement.recordSuccessNotes`)}</div>
          </div>
        </div>
      </div>

      <DisbursementCard id={id!} />

      <BtnToolbar>
        <BtnGroup> </BtnGroup>
        <BtnGroup>
          <Button action={ButtonAction.close} variant="secondary" onClick={onCancel} />
        </BtnGroup>
      </BtnToolbar>
    </>
  );
};
